<template>
  <div>
    <b-modal
      :title="`預領-${data.number}`"
      size="xl"
      centered
      hide-footer
      header-class="head-modal"
      v-model="modalShow"
    >
      <div class="operate">
        <div class="run">
          <b-button
            variant="primary"
            v-auth="`update`"
            @click="openModal()"
          >
            新增
          </b-button>
        </div>
      </div>

      <tables-page
        :tableData="table_data"
        :tableFields="table_fields"
        :pageData="page"
        @result="getLoan"
      >
        <template #cell(loan_at)="row">
          {{ convertRocDate(row.item.loan_at) }}
        </template>

        <template #cell(expiry_at)="row">
          {{ convertRocDate(row.item.expiry_at) }}
        </template>

        <template #cell(repayment_at)="row">
          {{ convertRocDate(row.item.repayment_at) }}
        </template>

        <template #cell(function)="row">
          <b-button
            variant="info"
            size="sm"
            v-auth="`update`"
            @click="openModal(row.item)"
          >
            編輯
          </b-button>

          <b-button
            variant="danger"
            size="sm"
            v-auth="`update`"
            @click="deleteLoan(row.item.id)"
          >
            刪除
          </b-button>
        </template>
      </tables-page>

      <b-overlay :show="status.isLoading" no-wrap></b-overlay>
    </b-modal>

     <!-- 契約設定modal -->
    <b-modal
      id="loanAddEdit-modal"
      ref="loanAddEdit-modal"
      :title="status.isNew ? '新增預領' : '修改預領'"
      size="lg"
      centered
      hide-footer
      header-class="head-modal"
      :no-close-on-backdrop="true"
    >
      <b-form-group label-cols="4" label-cols-lg="2" label="借款日" label-for="input-default">
        <date-picker
          v-model="temp_table_data.loan_at"
          :position="'left'" />
      </b-form-group>

      <b-form-group label-cols="4" label-cols-lg="2" label="到期日" label-for="input-default">
        <date-picker
          v-model="temp_table_data.expiry_at"
          :position="'left'" />
      </b-form-group>

      <b-form-group label-cols="4" label-cols-lg="2" label="還款日" label-for="input-default">
        <date-picker
          v-model="temp_table_data.repayment_at"
          :position="'left'" />
      </b-form-group>

      <b-form-group label-cols="4" label-cols-lg="2" label="金額" label-for="input-default">
        <b-form-input type="number" v-model="temp_table_data.amount" @input="changeAmount()"></b-form-input>
      </b-form-group>

      <b-form-group label-cols="4" label-cols-lg="2" label="手續費" label-for="input-default">
        <b-form-input type="number" v-model="temp_table_data.fee" placeholder="手續費為金額的12%，四捨五入自動換算，也可自行編輯"></b-form-input>
      </b-form-group>

      <div class="text-center mt-4">
        <b-button
          class="mr-2"
          variant="success"
          size="sm"
          @click="sumit()"
        >
          確定
        </b-button>
        <b-button
          variant="danger"
          size="sm"
          class="mr-4"
          @click="$bvModal.hide('loanAddEdit-modal')"
        >
          取消
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import TablesPage from "@/components/layouts/TablesPage";
import contractApi from "@/models/API/contractApi";
import { convertRocDate } from "@/models/HELPERS/common.js";
import datePicker from '@/components/common/DatePicker';

export default {
  name: 'LoanModal',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      required: false,
      default: false
    },
    data: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  components: {
    TablesPage,
    datePicker
  },
  data () {
    return {
      status: {
        isLoading: false,
        isNew: false
      },
      table_fields: [
        {
          key: "loan_at",
          label: "借款日",
        },
        {
          key: "expiry_at",
          label: "到期日",
        },
        {
          key: "repayment_at",
          label: "還款日",
        },
        {
          key: "amount",
          label: "金額",
        },
        {
          key: "fee",
          label: "手續費",
        },
        {
          key: "function",
          label: "功能"
        }
      ],
      page: {},
      table_data: [],
      temp_table_data: {},
    }
  },
  computed: {
    modalShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('change', value);
      }
    },
  },
  watch: {
    show: {
      handler(newValue, oldValue) {
        if (newValue) this.getLoan();
      },
      immediate: false
    }
  },
  mounted() {
    this.contractApi = new contractApi();
    this.load();
  },
  methods: {
    convertRocDate,
    // 首次載入讀取
    load() {
      this.page = Object.assign({}, this.contractApi.page);
    },
    // 開啟編輯modal
    openModal(item = null) {
      this.status.isNew = item ? false : true;

      this.$root.$emit('bv::show::modal', 'loanAddEdit-modal');
      this.temp_table_data = Object.assign({}, item);
    },
    // 查詢預領
    getLoan(pageIndex = null) {
      this.status.isLoading = true;

      const params = {
        'member_id': this.data.id,
        'PageSize': this.page.pageSize,
        'PageIndex': pageIndex ? pageIndex : this.page.pageIndex,
      };

      this.contractApi.getLoan((response) => {
        const res = response.data;

        this.page.totalCount = res.total;
        this.table_data = res.data;

        this.status.isLoading = false;
      }, params, false)
    },
    // 新增預領 || 更新預領
    sumit () {
      const check = this.fillVerification(this.temp_table_data);

      if (check) {
        this.temp_table_data.member_id = this.data.id;
        const fun = this.status.isNew ? 'addLoan' : 'updateLoan';
        const status_text = this.status.isNew ? '新增' : '更新';

        this.contractApi[fun]((response) => {
          const res = response.data;
          let result = {};

          if (res.code === 0) {
            result = { message: `預領${status_text}成功`, title: '預領' }

            this.getLoan(1);
            this.$root.$emit('bv::hide::modal', 'loanAddEdit-modal');

          } else if (res.code === 1) {
            result = { message: `預領${status_text}失敗`, title: '預領' };
          }

          this.contractApi.toast(() => {}, result, res.code === 0);
        }, this.temp_table_data, false)
      }
    },
    // 填寫驗證(全部為空會阻擋)
    fillVerification(data) {
      try {
        // 如果所有值都是空的或null，則返回true，否則返回false
        const status = !Object.values(data).every(value => value === null || value === '');

        if (!status) {
          throw { message: '欄位請填寫完整', title: this.status.isNew ? '新增預領' : '修改預領' };
        }

        return status;
      } catch(message) {
        this.contractApi.toast(() => {}, message, false);

        return false;
      }
    },
    // 刪除預領
    deleteLoan(id) {
      const r = confirm("確定刪除預領？");

      if (r) {
        this.contractApi.deleteLoan((response) => {
          const res = response.data;
          let result = {};

          if (res.code === 0) {
            result = { message: '預領刪除成功', title: '預領' }

            this.getLoan();
          } else if (res.code === 1) {
            result = { message: '預領刪除失敗', title: '預領' };
          }

          this.contractApi.toast(() => {}, result, res.code === 0);
        }, id, false)

        return true;
      }
      return false;
    },
     // 改變金額，手續費要自動換算12%
    changeAmount() {
      this.temp_table_data.fee = Math.round(this.temp_table_data.amount * 0.12);
    },
  }
}
</script>

<style lang="scss" scoped>
.operate {
  margin-bottom: 20px;
  .run {
    text-align: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Backstage/yf/components/modal/LoanModal.vue